import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {clarityAnalytics,newAnalyticsFlow} from '../analytics/clarity';
import {observeLanding} from '../analytics/behavior';
import {onPreferenceChange} from '../analytics/consent';

export default function PublicBehavior() {
  const {pathname}=useLocation();
  useEffect(()=>{
    let stop=null;
    const refresh=()=>{
      const enabled=pathname==='/'&&clarityAnalytics.canTrack();
      if(enabled&&!stop)stop=observeLanding({eligible:clarityAnalytics.canTrack,
        emit:clarityAnalytics.track,newFlow:newAnalyticsFlow});
      if(!enabled&&stop){stop();stop=null;}
    };
    refresh();const unsubscribe=onPreferenceChange(refresh);
    return ()=>{unsubscribe();if(stop)stop();};
  },[pathname]);
  return null;
}
